/* START_MODULE_CONTRACT
 * PURPOSE: Frontend model: Project.
 * SCOPE: DTO mapping / constants.
 * DEPENDS: M-FE-API
 * LINKS: M-FE-API
 * ROLE: TYPES
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * Project - Frontend model: Project.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: реальный class-контракт и парный END_CLASS.
 * END_CHANGE_SUMMARY
 */

/* START_CLASS_Project */
/* START_CONTRACT: Project
 * PURPOSE: Клиентская модель проекта с типизацией дат.
 * INPUTS: { id, name, createdAt } из API-ответа.
 * OUTPUTS: экземпляр Project (id, name, createdAt: Date|null).
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-API, M-PROJECT
 * END_CONTRACT: Project
 */
export default class Project {
  constructor({ id, name, createdAt }) {
    this.id = id;
    this.name = name ?? '';
    this.createdAt = createdAt ? new Date(createdAt) : null;
  }

  static fromResponse(data) {
    return new Project(data);
  }
}
/* END_CLASS_Project */
